import React, { useEffect } from 'react'
import useAuth from '../../../hooks/useAuth'
import { Helmet } from '@dr.pogodin/react-helmet'
import { Card as MuiCard, CardContent, Divider, LinearProgress, Typography } from '@mui/material'
import styled from '@emotion/styled'
import { spacing } from '@mui/system'
import { useTranslation } from 'react-i18next'
import WarrantsGrid from '../../../components/entities/WarrantsGrid'
import WarrantApi from '../../../api/WarrantApi'

const Card = styled(MuiCard)(spacing)
const warrantApi = new WarrantApi()

function WarrantsView() {
    const { t } = useTranslation()
    const { isAuthenticated } = useAuth()

    const [warrants, setWarrants] = React.useState(null)
    const compareWarrants = (a, b) => {
        // compare shareName, name
        if (a.shareName > b.shareName) return 1
        if (a.shareName < b.shareName) return -1
        if (a.name > b.name) return 1
        if (a.name < b.name) return -1
        return 0
    }
    useEffect(() => {
        async function fetchData() {
            if (!isAuthenticated) return
            const fetchedWarrants = await warrantApi.findAll()
            // filter warrant            // sort by shareName, name
            fetchedWarrants.sort((a, b) => compareWarrants(a, b))
            setWarrants(fetchedWarrants)
        }
        fetchData()
    }, [isAuthenticated])

    return (
        <React.Fragment>
            <Helmet title={t('entities.warrant.plural')} />
            <Typography
                variant='h3'
                gutterBottom
                sx={{
                    display: 'block',
                }}
            >
                {t('entities.warrant.plural')}
            </Typography>
            <Divider my={6} />
            <Card mb={6}>
                <CardContent>
                    {!warrants && <LinearProgress />}
                    {warrants && (
                        <WarrantsGrid
                            warrants={warrants}
                            pagination={true}
                            pageSizeInitialState={100}
                            pageSizeOptions={[10, 25, 100]}
                            detailsPath={(c) => `/admin/warrants/${c.id}`}
                            fields={['name', 'status']}
                            sortModel={[
                                { field: 'status', sort: 'asc' },
                                { field: 'updatedAt', sort: 'desc' },
                            ]}
                        />
                    )}
                </CardContent>
            </Card>
        </React.Fragment>
    )
}

export default WarrantsView
